import React, { useEffect, useState } from "react";
import SideImage from "../../Assets/SideImage.png";
import Footer from "../../Components/Footer";
import Navbar from "../../Components/Navbar";
import axios from "axios";
import { useForm } from "react-hook-form";
import { baseURL } from "../../Utils/api";
import "./ForgotPassword.css";
import { BallTriangle } from "react-loader-spinner";
import { Alert, Button, TextField } from "@mui/material";
import Swal from "sweetalert2";
import { validatePassword } from "../../Utils/validation";
import { useNavigate, useParams } from "react-router";
import { InvitedUser } from "./Helper";

const ForgotPassword = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [otpToken, setOtpToken] = useState("");
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [emailVerified, setEmailVerified] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [loading, setLoading] = useState(false);
  const [inValidEmailAlert, setInValidEmailAlert] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(()=>{
    if(id){
      InvitedUser(id).then((res) => {
        if(!res.data?.result?.isInvite){
          setEmailVerified(true);
          setEmail(res.data?.result?.email)
        }else{
          Swal.fire("", "Invalid Password Reset Link", "info");
          navigate("/signin")
        }
      });
    }
  },[id])

  useEffect(()=>{

  },[emailVerified])

  function requestOTP(data) {
    axios
      .post(`${baseURL}/auth/resetpasswordotp`, { email: data.email })
      .then((response) => {
        setEmail(data.email);
        setOtpToken(response.data.token);
      })
      .catch((error) => {
        if (error?.response?.status === 404) {
          setInValidEmailAlert(error.response.data.msg);
        } else {
          setInValidEmailAlert("Something went wrong");
        }
        console.log(error.message);
      });
  }

  function verifyOTP(e) {
    e.preventDefault();
    if (!otpToken || !code) {
      return;
    }
    axios
      .post(`${baseURL}/auth/verifyotp`, { OTPToken: otpToken, OTP: code })
      .then(() => {
        setEmailVerified(true);
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          title: error.response?.data?.msg,
          icon: "error",
        });
      });
  }

  async function setPasswordSubmit(e) {
    e.preventDefault();
    if (!emailVerified || !CheckPassword()) {
      return;
    }
    if(password!==confirmPassword){
      Swal.fire("", "Password is not matching with confirm password", "info")
      return;
    }
    setLoading(true);
    // let keycloakid = "";
    // await axios
    //   .post(`${baseURL}/auth/getuserinfo`, {
    //     email: email,
    //   })
    //   .then((response) => {
    //     keycloakid = response.data.result.id;
    //   })
    //   .catch((error) => console.log(error.message));

    await axios
      .post(`${baseURL}/auth/setpassword`, {
        email: email,
        inviteId: id,
        newPassword: password,
      })
      .then((res) => {
        setLoading(false);
        if(res?.status === 200){
          Swal.fire("", "Password updated successfully", "success").then(()=>{
            navigate("/signin")
          })
        }else{
          Swal.fire("", "Unable to update password", "info").then(()=>{
            navigate("/signin")
          })
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        Swal.fire("", "Something went wrong", "error")
        navigate("/signin")
      });
  }
  function CheckPassword() {
    const res = validatePassword(password);
    if (res === true) {
      return true;
    } else {
      setPasswordError(res);
      return false;
    }
  }
  return (
    <div className="flex flex-col min-h-screen">
      {loading ? (
        <div className="flex flex-col bg-gradient-to-r from-green-100 to-green-50 justify-center h-screen items-center">
          <BallTriangle
            height={100}
            width={100}
            radius={5}
            color="#4fa94d"
            ariaLabel="ball-triangle-loading"
            wrapperClass={{}}
            wrapperStyle=""
            visible={true}
          />
          <span className="mt-4 text-2xl text-green-700">
            Updaing Your Password..
          </span>
        </div>
      ) : (
        <>
          <Navbar />
          <div className="grid grid-cols-2 gap-5">
            <div className="bg-[#EDFDF9] flex items-center justify-center">
              <img src={SideImage} className="w-[80vh]" alt="side_image" />
            </div>
            <div className="flex items-center justify-center">
              <div className="container w-full">
                {!otpToken && !id && (
                  <form className="w-full" onSubmit={handleSubmit(requestOTP)}>
                    <div className="p-40">
                      <div className="font-medium mb-6 text-lg">
                        Forgot Password
                      </div>
                      {inValidEmailAlert && (
                        <Alert severity={"error"} className="mb-4">
                          {inValidEmailAlert}
                        </Alert>
                      )}
                      <TextField
                        type="text"
                        label="Email"
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address",
                          },
                        })}
                        fullWidth
                      />
                      {errors.email ? (
                        <h4 className="text-red-600 text-xs pt-2 pb-2">
                          {errors.email.message}
                        </h4>
                      ) : (
                        ""
                      )}
                      {!errors.email ? <br /> : ""}
                      {!errors.email ? <br /> : ""}
                      <Button
                        type="submit"
                        variant="contained"
                        style={{ color: "#FFFFFF" }}
                        fullWidth
                      >
                        Request OTP
                      </Button>
                    </div>
                  </form>
                )}
                {!emailVerified && otpToken && (
                  <div className="otp-container">
                    <form className="otp-form-container" onSubmit={verifyOTP}>
                      <p className="mb-4">
                        Check your email and use the OTP sent to you.
                      </p>
                      <input
                        type="number"
                        id="otp"
                        name="otp"
                        value={code}
                        className="mb-5"
                        onChange={(e) => setCode(e.target.value)}
                      />
                      <Button
                        type="submit"
                        variant="contained"
                        style={{ color: "#FFFFFF" }}
                        fullWidth
                      >
                        Verify OTP
                      </Button>
                    </form>
                  </div>
                )}
                {emailVerified && (
                  <div>
                    <form onSubmit={setPasswordSubmit}>
                      <h2 className="mb-3">Set new password for your account</h2>
                      <TextField
                        className="mb-3"
                        type="password"
                        id="outlined-basic"
                        margin="normal"
                        onChange={(e) => setPassword(e.target.value)}
                        label="Password"
                        variant="outlined"
                        fullWidth
                      />
                      <TextField
                        className="mb-3"
                        type="password"
                        id="outlined-basic"
                        margin="normal"
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        label="Confirm Password"
                        variant="outlined"
                        fullWidth
                      />
                      {passwordError.length > 0 && (
                        <h4 className="text-red-600 text-xs pt-2 pb-2">
                          {passwordError}
                        </h4>
                      )}
                      <Button
                        type="submit"
                        variant="contained"
                        style={{ color: "#FFFFFF" }}
                        fullWidth
                      >
                        { id ? "Set Password" : "Change Password"}
                      </Button>
                    </form>
                  </div>
                )}
              </div>
            </div>
          </div>
          <Footer />
        </>
      )}
    </div>
  );
};

export default ForgotPassword;
